import { render, staticRenderFns } from "./VisitApprovalList.vue?vue&type=template&id=3a25e55a&scoped=true&"
import script from "./VisitApprovalList.vue?vue&type=script&lang=js&"
export * from "./VisitApprovalList.vue?vue&type=script&lang=js&"
import style0 from "./VisitApprovalList.vue?vue&type=style&index=0&id=3a25e55a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a25e55a",
  null
  
)

export default component.exports